﻿

$(document).ready(function () {
    var myOpeningHoursSubscriptionPage = new OpeningHoursSubscriptionPage();
    myOpeningHoursSubscriptionPage.init();
    $(".facility-subscription-dropdown").on("change select", function () {
        //Check whether option with value  exists
        var option = $("option[value='" + this.value + "']", this);
        if (option && option.length > 0) {
            option
                .attr("selected", true).siblings()
                .removeAttr("selected");
        }
    });
    // enhance table saw to make responsive table
    $(document).trigger("enhance.tablesaw");
});

var OpeningHoursSubscriptionFunction = OpeningHoursSubscriptionFunction || (function () {
    var blockUI = function () {
        $("#loader").show();
    };
    var unBlockUI = function () {
        $("#loader").hide();
    };
    var disableButtons = function () {
        $(".js-facilities-subscribed-by-user").addClass("disabled-btn");
        $(".js-facility-information-subscription").addClass("disabled-btn");
    };
    var enableButtons = function () {
        $(".js-facilities-subscribed-by-user").removeClass("disabled-btn");
        $(".js-facility-information-subscription").removeClass("disabled-btn");
    };

    return {
        blockUI: blockUI,
        unBlockUI: unBlockUI,
        enableButtons: enableButtons,
        disableButtons: disableButtons
    };
})();

var OpeningHoursSubscriptionPage = function () {

    var hideFacilityInformationSubscription = function () {
        $('.js-hide-show-facility-subscription-information').hide();
    };

    var showFacilityInformationSubscription = function () {
        $('.js-hide-show-facility-subscription-information').show();
    };

    var getCurrentlySelectedFacility = function () {
        return $("#SelectedFacilityId").val().split('_')[0];
    };
    var getCurrentlySelectedFacilityName = function () {
        return $('.facility-subscription-dropdown :selected').text();
    };
    var requests = [];

    var fetchFacilitySubscriptionInformation = function () {
        var selectedFacilityId = getCurrentlySelectedFacility();
        hideFacilityInformationSubscription();
        OpeningHoursSubscriptionFunction.blockUI();
        $.each(requests, function (index, request) {
            request.abort();
        });
        requests = [];
        var facilitySubscriptionInformationUrl = "/api/facility-opening-hours-subscription/facility-subscription-information";
        var facilitySubscriptionUrl = "/api/facility-opening-hours-subscription/facility-subscription";
        var parameters = {
            facilityId: selectedFacilityId
        };

        var facilitySubscriptionInformationDefered = $.ajax({
            type: "Get",
            url: facilitySubscriptionInformationUrl,
            async: true,
            cache: false,
            data: parameters,
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (data) {
                if (data) {
                    if (data.facilitySubscriptionInformation && data.facilitySubscriptionInformation.length !== 0) {
                        $('.facilitySubscriptionInformationPlaceHolder').html(data.facilitySubscriptionInformation);
                        $('.selected-facility-name').html(getCurrentlySelectedFacilityName());
                        /* little fade in effect */
                        $('.facilitySubscriptionInformationPlaceHolder').fadeIn('fast');
                    }
                }
            },
            error: function (jqXHR, status, exception) {
                console.error("Something went wrong with the AJAX request for fetching FacilitySubscriptionInformation!" + "</br>" + exception.Message);
                $('.facilitySubscriptionInformationPlaceHolder').html("<h2>Failed to fetch facility subscription information</h2>");
            }
        });
        var facilitySubscriptionDefered = $.ajax({
            type: "Get",
            url: facilitySubscriptionUrl,
            async: true,
            cache: false,
            data: parameters,
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (data) {
                if (data) {
                    var isFacilitySubscribed = data.isFacilitySubscribedByUser;
                    if (isFacilitySubscribed) {
                        $(".js-facility-information-subscription").addClass("active");
                    } else {
                        $(".js-facility-information-subscription").removeClass("active");
                    }
                    $(".js-facility-information-subscription")[0].setAttribute('customernumber', data.customerNumber);
                    $(".js-facility-information-subscription")[0].setAttribute('userid', data.userId);
                    $(".js-facility-information-subscription")[0].setAttribute('facilityid', data.facilityId);
                }
            },
            error: function (jqXHR, status, exception) {
                console.error("Something went wrong with the AJAX request for fetching FacilitySubscription!" + "</br>" + exception.Message);
            }
        });
        requests.push(facilitySubscriptionInformationDefered);
        requests.push(facilitySubscriptionDefered);
        $.when.apply($, requests).then(function () {
            OpeningHoursSubscriptionFunction.unBlockUI();
            showFacilityInformationSubscription();
        });
    };
    var saveFacilityInformationSubscription = function (facilitySubscription, isNewSubscription) {
        OpeningHoursSubscriptionFunction.disableButtons();
        OpeningHoursSubscriptionFunction.blockUI();
        var tableResult = $('#facility-opening-hours-subscriptions');
        $.ajax({
            url: `/api/facility-opening-hours-subscription/SaveFacilitySubscription?isNewSubscription=${isNewSubscription}`,
            type: "POST",
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(facilitySubscription),
            cache: false,
            success: function (data) {
                OpeningHoursSubscriptionFunction.enableButtons();
                OpeningHoursSubscriptionFunction.unBlockUI();

                if (!data) {
                    return;
                }

                if (
                    data.facilityInformationSubscriptions &&
                    data.facilityInformationSubscriptions.length !== 0
                ) {
                    tableResult.html(data.facilityInformationSubscriptions);
                    /* little fade in effect */
                    tableResult.fadeIn('fast');

                    const subscriptionClassName = '.js-facility-information-subscription';
                    if (
                        !$('.js-hide-show-facility-subscription-information').hasClass('hidden') &&
                        $(subscriptionClassName)[0].getAttribute('facilityid') ==
                            facilitySubscription.FacilityId
                    ) {
                        if (isNewSubscription) {
                            if (!$(subscriptionClassName).hasClass('active')) {
                                $(subscriptionClassName).addClass('active');
                            }
                        } else if ($(subscriptionClassName).hasClass('active')) {
                            $(subscriptionClassName).removeClass('active');
                        }
                    }
                }
            },
            error: function (jqXHR, status, exception) {
                OpeningHoursSubscriptionFunction.enableButtons();
                OpeningHoursSubscriptionFunction.unBlockUI();
                console.error("Something went wrong with the AJAX request for saving FacilityInformationSubscription!" + "</br>" + exception.Message);
                tableResult.empty();
            }
        });
        return false;
    };
    var fetchFacilitySubscriptionInformationEvent = function () {
        $(".facility-subscription-dropdown").on("change", function () {
            fetchFacilitySubscriptionInformation();
        });
    };
    var saveFacilitySubscriptionEvent = function (obj, facilitySubscription) {

        if ($(obj).hasClass("active")) {
            saveFacilityInformationSubscription(facilitySubscription, false);
            $(obj).toggleClass("active");
        } else {
            var count = $("#facility-subscription-count").val();
            if (parseInt(count) < 10) {
                saveFacilityInformationSubscription(facilitySubscription, true);
                $(obj).toggleClass("active");
            } else {
                $("#max-facility-subscription-modal").show();
            }
        }
    };
    var facilitiesSubscribedByUserClickEvent = function () {
        $(document).on("click", ".js-facilities-subscribed-by-user", function (e) {
            e.stopPropagation();
            var facilitySubscription = {
                CustomerNumber: $(this).data("customernumber"),
                UserId: $(this).data("userid"),
                FacilityId: $(this).data("facilityid")
            };
            saveFacilitySubscriptionEvent($(this),facilitySubscription);
        });
    };
    var facilityInformationSubscriptionClickEvent = function () {
        $(document).on("click", ".js-facility-information-subscription", function (e) {
            e.stopPropagation();
            var facilitySubscription = {
                CustomerNumber: $(this)[0].getAttribute('customernumber'),
                UserId: $(this)[0].getAttribute('userid'),
                FacilityId: $(this)[0].getAttribute('facilityid')
            };
            saveFacilitySubscriptionEvent($(this),facilitySubscription);
        });
    };
    var init = function () {
        fetchFacilitySubscriptionInformationEvent();
        facilitiesSubscribedByUserClickEvent();
        facilityInformationSubscriptionClickEvent();
    };
    return {
        init: init
    };
};
